import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import buttonUp from '../../images/top/button_up.svg'
import { Helmet, HelmetProvider } from 'react-helmet-async'

import { makeStyles, Theme } from '@material-ui/core/styles'
import { getCategoryFaqs, getFaqs } from 'apis/faq'
import { Faq } from 'apis/response_types'
import { useHistory, useParams } from 'react-router-dom'
import BreadCrumbs, { BreadCrumb } from 'components/common/BreadCrumbs'
import ReactHtmlParser from 'react-html-parser'
import { BorderBottom } from '@material-ui/icons'
import iconSearch from '../../components/landingpage/assets/icon_faq_search.svg'
import MetaTag from 'components/common/MetaTag'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  }
}))

export default function FaqView() {
  const classes = useStyles()
  const history = useHistory()
  const params = new URLSearchParams(window.location.search)
  let { faq_id } = useParams<{
    faq_id: string
  }>()
  const categoryId = params.get('categoryId') || ''
  const [faqs, setFaqs] = useState<Faq[] | null>([])
  const [category, setCategory] = useState<string>('')
  const [targetFaq, setTargetFaq] = useState<Faq>()
  const [searchKeyword, setSearchKeyword] = useState<string>('')
  const breadcrumbsList: BreadCrumb[] = [
    { name: 'よくある質問', to: '/faq' },
    { name: category, to: `/faq/search?categoryId=${categoryId}` },
    { name: targetFaq?.question || '' }
  ]

  useEffect(() => {
    ;(async () => {
      let targetCategoryId = categoryId
      if (!categoryId) {
        const faqCategory = await getFaqs({ search: faq_id })
        targetCategoryId = faqCategory.data.data[0].categories[0].id
      }
      const faqResponse = await getFaqs({
        search: targetCategoryId,
        s: 'order'
      })
      setFaqs(faqResponse.data.data)
      if (faqs) {
        setCategory(faqResponse.data.data[0].categories[0].category)
      }
      for (const reData of faqResponse.data?.data) {
        if (reData.id == faq_id) {
          setTargetFaq(reData)
          break
        }
      }
    })()
  }, [])

  const handleSearchEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.nativeEvent.isComposing || e.key !== 'Enter') return
    history.push(`/faq/search?keyword=${searchKeyword}`)
  }

  return (
    <React.Fragment>
      <MetaTag
        title="よくある質問 - オンラインサロンYOOR（ユア）"
        description="YOORは、専用トークルームを完備したオンラインサロンプラットフォームです。YOORに関してよくある質問を掲載しております。お問い合わせの前にぜひご利用ください。"
      />

      <div className="faq" style={{ borderTop: '1px solid #DCDCDC' }}>
        <BreadCrumbsStyled breadcrumbsList={breadcrumbsList} />
        <div className="faq-list-header">
          <div className="faq-list-find">
            <div className="input-control">
              <img src={iconSearch} className="icon" alt="" />
              <input
                placeholder="検索"
                onChange={(e) => {
                  setSearchKeyword(e.target.value)
                }}
                onKeyDown={handleSearchEnter}
              />
            </div>
          </div>
          <div className="faqList-head-text">
            <h1>{targetFaq?.question || ''}</h1>
          </div>
        </div>
        <div className="faq-body">
          <div className="pb3" id="a-faq">
            <div className="faq-detail">
              {ReactHtmlParser(targetFaq?.answer || '')}
            </div>
            <h3 className="faq-other-tilte">
              その他の「{category}」よくある質問
            </h3>
            <div className="section-inner">
              {faqs?.map((faq) => {
                if (faq.id != faq_id) {
                  return (
                    <div key={faq.id} className="faq-item">
                      <a
                        href={`/faq/${faq.id}?categoryId=${faq.categories[0].id}`}
                      >
                        {faq.question}
                      </a>
                    </div>
                  )
                }
              })}
            </div>
            <div className="faqTopLink">
              <a href="/faq">よくある質問トップへ</a>
            </div>
          </div>
        </div>
      </div>
      <div className="pagetop -guideline">
        <a href="#">
          <img alt="buttonup" src={buttonUp} width="54" height="54" />
        </a>
      </div>
    </React.Fragment>
  )
}

const BreadCrumbsStyled = styled(BreadCrumbs)`
  max-width: 960px;
  margin: 24px auto 0;
  padding: 0 24px;
  @media (max-width: 640px) {
    margin: 0 auto;
    padding: 0 20px;
  }
  li {
    &:nth-child(3) {
      display: none;
    }
  }
`